import React from "react";
import { Typography, Alert, Fade, Stack, alpha, useTheme } from "@mui/material";
import { CheckCircle } from "@mui/icons-material";
export default function DoneStep({ phoneNumber }) {
  const theme = useTheme();
  return (
    <Fade in timeout={400}>
      <Stack spacing={3} alignItems="center" textAlign="center">
        <CheckCircle sx={{ fontSize: 100, color: "success.main" }} />


        <Typography variant="h5" fontWeight="bold" color="success.main">
          ثبت شد!
        </Typography>

        <Typography variant="body1" color="text.secondary">
          رسید واریزی شما دریافت شد. کارشناسان ما در حال بررسی هستند.
        </Typography>

        <Alert
          severity="success"
          sx={{
            width: "100%",
            borderRadius: 3,
            backgroundColor: alpha(theme.palette.success.main, 0.1),
            gap: "8px",
          }}
        >
          <Stack>
            <Typography variant="body2">
              مراحل بعدی همکاری از طریق پیامک به شماره {phoneNumber} ارسال خواهد
              شد.
            </Typography>
            <Typography variant="caption" sx={{ mt: 1 }}>
              شماره پیگیری: COOP-{Math.floor(Math.random() * 1000000)}
            </Typography>
          </Stack>
        </Alert>
      </Stack>
    </Fade>
  );
}
